export default "__VITE_ASSET__21e205d2__"